import { render } from "./TitleText.vue?vue&type=template&id=e8371d44"
import script from "./TitleText.vue?vue&type=script&lang=js"
export * from "./TitleText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/unipar/Code/neo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__